import { FlexiToggle } from "appworks/graphics/elements/flexi-toggle";
import { slotModel } from "slotworks/model/slot-model";
import { ToggleControl } from "./toggle-control";

export class StopOnWinToggleControl extends ToggleControl {
    constructor(protected toggle: FlexiToggle) {
        super(toggle);

        const { stopOnAnyWin } = slotModel.read().autoplay;
        this.toggle.setValue(stopOnAnyWin);
    }

    protected onChange(stopOnAnyWin: boolean): void {
        slotModel.write({ autoplay: { stopOnAnyWin } });
    }
}
